import { TextInfoField } from "#common/Texto"
import Box from "@mui/material/Box"
import ButtonIcon from "#common/buttons/ButtonIcon"
import { MasterDialog } from "#common/Dialog/Dialog"
import { InputDate } from "#common/input/InputDate"
import { useApiSend } from "#hooks/useApiSend"
import EditCalendarIcon from "@mui/icons-material/EditCalendar"
import { Stack } from "@mui/material"
import { bajaPut } from "Components/bajas/services/api"
import dayjs from "dayjs"
import { Fragment, useEffect, useState } from "react"
import * as TEXT from "../../TextBaja"
import { UseDialogBajaContext } from "./DialogBajaContext"

export default function EditTerminationDate({ id, termination_date }) {
	return (
		<Box>
			<Stack spacing={1} direction={"row"}>
				<TextInfoField
					whiteSpace="pre-line"
					{...{ campo: TEXT.TERMINATION_DATE, valor: termination_date }}
					separador={"\n"}
				/>
				<EditTerminationDateDialog id={id} termination_date={termination_date} />
			</Stack>
		</Box>
	)
}
const EditTerminationDateDialog = ({ id, termination_date }) => {
	const { reload } = UseDialogBajaContext()
	const [open, setOpen] = useState(false)
	const [disabled, setDisabled] = useState(false)
	const [date, setDate] = useState(null)
	const success = () => {
		setOpen(false)
		reload()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(bajaPut, { success, end })
	const send = () => {
		setDisabled(true)
		const new_date = date?.format("YYYY-MM-DD")
		fetch(id, { termination_date: new_date })
	}
	useEffect(() => {
		const fecha1 = dayjs(termination_date, "DD/MM/YYYY")
		setDate(fecha1)
	}, [termination_date])

	return (
		<Fragment>
			<ButtonIcon
				title="Editar Fecha"
				icon={<EditCalendarIcon />}
				onClick={() => setOpen(true)}
			/>

			<MasterDialog
				{...{ open, setOpen }}
				title={"Editar Fecha De Baja"}
				buttons={[{ label: "editar", onClick: send, disabled: disabled }]}
				maxWidth={"md"}
			>
				<Box>
					<Stack alignItems={"center"} spacing={2}>
						<InputDate
							label={TEXT.TERMINATION_DATE}
							value={date}
							onChange={(date) => setDate(date)}
							// disablePast={!isRH}
						/>
					</Stack>
				</Box>
			</MasterDialog>
		</Fragment>
	)
}
